import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import Task from './Task';
import { UNASSIGNED_TASKS_POOL_ID } from '../helpers/constants';

const UnassignedTasksPool = ({ tasks, handleEditTask }) => {
    return (
        <Droppable droppableId={UNASSIGNED_TASKS_POOL_ID}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{
                        background: snapshot.isDraggingOver
                            ? '#ffcd9e'
                            : '#fef2e8',
                        padding: 16,
                        minHeight: '100%',
                    }}
                >
                    <h3 style={{ textAlign: 'center' }}>Unassigned Tasks</h3>
                    {tasks.map((task, index) => (
                        <Task
                            key={task.id}
                            task={task}
                            index={index}
                            taskType='unassigned'
                            handleEditTask={handleEditTask}
                        />
                    ))}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
};

UnassignedTasksPool.propTypes = {
    tasks: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            title: PropTypes.string.isRequired,
            hotelApartment: PropTypes.string,
            duration: PropTypes.string,
            deadline: PropTypes.string,
        })
    ).isRequired,
    handleEditTask: PropTypes.func.isRequired,
};

export default UnassignedTasksPool;
